import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const API_TIMEOUT_MS = 15000;

const api = axios.create({
  baseURL: API_BASE,
  timeout: API_TIMEOUT_MS,
});

export default api;

// Lawyers
export const fetchLawyers = (params = {}) => api.get('/lawyers', { params }).then((r) => r.data);
export const fetchLawyer = (id) => api.get(`/lawyers/${id}`).then((r) => r.data);
export const fetchSpecialties = () => api.get('/specialties').then((r) => r.data);
export const contactLawyer = (payload) => api.post('/lawyer-contact', payload).then((r) => r.data);

// Guides
export const fetchGuides = (params = {}) => api.get('/guides', { params }).then((r) => r.data);
export const fetchGuide = (id) => api.get(`/guides/${id}`).then((r) => r.data);
export const fetchGuideCategories = () => api.get('/guide-categories').then((r) => r.data);

// Free Aid
export const submitAidRequest = (payload) => api.post('/aid-requests', payload).then((r) => r.data);
export const trackAidRequest = (payload) => api.post('/track/aid', payload).then((r) => r.data);
export const fetchAidStatuses = () => api.get('/aid-statuses').then((r) => r.data);

// Messages
export const submitMessage = (payload) => api.post('/messages', payload).then((r) => r.data);

// Stats
export const fetchStats = () => api.get('/stats').then((r) => r.data);

// Products & Orders
export const fetchProducts = (params = {}) => api.get('/products', { params }).then((r) => r.data);
export const fetchProduct = (id) => api.get(`/products/${id}`).then((r) => r.data);
export const fetchProductCategories = () => api.get('/product-categories').then((r) => r.data);
export const fetchPaymentConfig = () => api.get('/payment-config').then((r) => r.data);
export const createOrder = (payload) => api.post('/orders/create', payload).then((r) => r.data);
export const verifyOrder = (payload) => api.post('/orders/verify', payload).then((r) => r.data);
export const reconcileOrder = (orderId) => api.post(`/orders/${orderId}/reconcile`).then((r) => r.data);
export const adminReconcileOrder = (passcode, orderId) =>
  api.post(`/admin/orders/${orderId}/reconcile`, {}, { headers: { 'X-Admin-Passcode': passcode } }).then((r) => r.data);
export const fetchOrder = (id) => api.get(`/orders/${id}`).then((r) => r.data);

// Advocate self-enrollment
export const fetchEnrollmentConfig = () => api.get('/enrollment-config').then((r) => r.data);
export const enrollAdvocate = (payload) => api.post('/enroll-advocate', payload).then((r) => r.data);
export const adminListLawyers = (passcode, params = {}) =>
  api.get('/admin/lawyers', { headers: { 'X-Admin-Passcode': passcode }, params }).then((r) => r.data);
export const adminApproveLawyer = (passcode, id) =>
  api.post(`/admin/lawyers/${id}/approve`, {}, { headers: { 'X-Admin-Passcode': passcode } }).then((r) => r.data);
export const adminRejectLawyer = (passcode, id, reason) =>
  api.post(`/admin/lawyers/${id}/reject`, { reason }, { headers: { 'X-Admin-Passcode': passcode } }).then((r) => r.data);

// Admin
export const adminLogin = (passcode) => api.post('/admin/login', { passcode }).then((r) => r.data);
export const fetchAdminOverview = (passcode) =>
  api.get('/admin/overview', { headers: { 'X-Admin-Passcode': passcode } }).then((r) => r.data);
export const updateAidStatus = (passcode, id, status) =>
  api
    .patch(`/admin/aid-requests/${id}`, { status }, { headers: { 'X-Admin-Passcode': passcode } })
    .then((r) => r.data);
export const adminCreateLawyer = (passcode, payload) =>
  api.post('/admin/lawyers', payload, { headers: { 'X-Admin-Passcode': passcode } }).then((r) => r.data);
export const adminUpdateLawyer = (passcode, id, payload) =>
  api.patch(`/admin/lawyers/${id}`, payload, { headers: { 'X-Admin-Passcode': passcode } }).then((r) => r.data);
export const adminDeleteLawyer = (passcode, id) =>
  api.delete(`/admin/lawyers/${id}`, { headers: { 'X-Admin-Passcode': passcode } }).then((r) => r.data);
export const adminBulkUploadLawyers = (passcode, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api
    .post('/admin/lawyers/bulk', fd, {
      headers: { 'X-Admin-Passcode': passcode, 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
    })
    .then((r) => r.data);
};
export const fetchLawyerCsvTemplate = (passcode) =>
  api.get('/admin/lawyers/template', { headers: { 'X-Admin-Passcode': passcode } }).then((r) => r.data);
export const adminCreateGuide = (passcode, payload) =>
  api.post('/admin/guides', payload, { headers: { 'X-Admin-Passcode': passcode } }).then((r) => r.data);
export const adminUpdateGuide = (passcode, id, payload) =>
  api.patch(`/admin/guides/${id}`, payload, { headers: { 'X-Admin-Passcode': passcode } }).then((r) => r.data);
export const adminDeleteGuide = (passcode, id) =>
  api.delete(`/admin/guides/${id}`, { headers: { 'X-Admin-Passcode': passcode } }).then((r) => r.data);
export const adminCreateProduct = (passcode, payload) =>
  api.post('/admin/products', payload, { headers: { 'X-Admin-Passcode': passcode } }).then((r) => r.data);
export const adminUpdateProduct = (passcode, id, payload) =>
  api.patch(`/admin/products/${id}`, payload, { headers: { 'X-Admin-Passcode': passcode } }).then((r) => r.data);
export const adminDeleteProduct = (passcode, id) =>
  api.delete(`/admin/products/${id}`, { headers: { 'X-Admin-Passcode': passcode } }).then((r) => r.data);
export const adminListOrders = (passcode, params = {}) =>
  api.get('/admin/orders', { headers: { 'X-Admin-Passcode': passcode }, params }).then((r) => r.data);
